import * as React from "react"
import { ActivityEventCard } from "./ActivityEventCard"
import type { ActivityEvent } from "./types"

export function ActivityFeed({
  events,
  eventsPath,
  renderSummary,
  emptyMessage = "No activity yet. Decisions, edits, and your comments will appear here.",
}: {
  events: ActivityEvent[]
  eventsPath: string
  renderSummary: (event: ActivityEvent) => React.ReactNode
  emptyMessage?: string
}) {
  if (events.length === 0) {
    return (
      <div className="rounded-md border border-dashed border-hairline px-4 py-8 text-center text-ink-muted">
        {emptyMessage}
      </div>
    )
  }

  return (
    <ol className="flex flex-col gap-12">
      {events.map((event) => (
        <li key={event.id}>
          <ActivityEventCard
            event={event}
            eventsPath={eventsPath}
            renderSummary={renderSummary}
          />
        </li>
      ))}
    </ol>
  )
}
